import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';

@Component({
  selector: 'lib-checkbox',
  imports: [CommonModule],
  templateUrl: './checkbox.component.html',
  styles: ``
})
export class CheckboxComponent {

  label = input<string>("");
  checked = input<boolean>(false);
  className = input<string>('');
  id = input<string | null>(null);
  disabled = input<boolean>(false);
  checkedChange = output<boolean>();

  onChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.checkedChange.emit(input.checked);
  }
}
